<template>
  <div>
    <CartItem v-for="item in items" :key="item.id" :item="item" />

    <div class="level is-size-4 is-size-4-mobile is-mobile is-marginless" v-if="subtotal !== total">
      <div class="level-left">
        <div class="level-item is-size-6-mobile">{{ $t('general.running-sum') }}</div>
      </div>
      <div class="level-right has-text-right">
        <div class="level-item">{{ currency | currency }} {{ subtotal | amount }}</div>
      </div>
    </div>

    <div v-if="shipping && shipping > 0" class="level is-size-4 is-size-4-mobile is-mobile is-marginless">
      <div class="level-left">
        <div class="level-item is-size-6-mobile">
          {{ $t('general.shipping') }}
        </div>
      </div>
      <div class="level-right has-text-right">
        <div class="level-item">{{ currency | currency }} {{ shipping | amount }}</div>
      </div>
    </div>

    <div v-if="fees && fees.length > 0" class="level is-size-4 is-size-4-mobile is-mobile is-marginless">
      <div class="level-left">
        <div class="level-item is-size-6-mobile">
          {{ $t('general.fees') }}
        </div>
      </div>
      <div class="level-right has-text-right">
        <div class="level-item">{{ currency | currency }} {{ 0 | amount }}</div>
      </div>
    </div>
    <div v-if="totalReduction != 0" class="level is-size-4 is-size-4-mobile is-mobile is-marginless">
      <div class="level-left">
        <div class="level-item is-size-6-mobile">
          <p>{{ $t('general.less-abrev') }} {{ $t('general.promotion-code') }}</p>
        </div>
      </div>
      <div class="level-right has-text-right">
        <div class="level-item">{{ currency | currency }} {{ totalReduction | amount }}</div>
      </div>
    </div>

    <div v-if="prepaid && prepaid.length > 0">
      <div class="level is-size-4 is-size-4-mobile is-mobile prepaid my-2" v-for="pp of prepaid" :key="pp.id">
        <div class="level-left">
          <div class="level-item">
            <div>
              <span class="is-size-7">{{ $t('general.less-abrev') }}</span> <span class="is-size-6 ">{{ $t('general.credit') }}</span>
              <p class="is-size-6 has-text-weight-semibold is-block-mobile prepaid-name is-italic u-text--ellipsis">({{ pp.name }})</p>

              <b-button type="is-text" class="pl-0 pt-0 is-size-7 is-block" v-if="pp.remove" @click="properRemoveGiftCard(pp.remove)">{{ $t('general.remove') }}</b-button>
            </div>
          </div>
        </div>
        <div class="level-right has-text-right">
          <div class="level-item">- {{ currency | currency }} {{ pp.amount | amount }}<br /></div>
        </div>
      </div>
    </div>

    <div class="level is-size-4 is-size-4-mobile is-mobile is-marginless has-text-weight-semibold">
      <div class="level-left">
        <div class="level-item">{{ $t('general.total') }}</div>
      </div>
      <div class="level-right has-text-right">
        <div class="level-item">{{ currency | currency }} {{ total | amount }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import CartItem from './CartItem'
import {mapGetters, mapActions} from 'vuex'
export default {
  name: 'Cart',
  components: {
    CartItem,
  },
  props: {
    items: Array,
    currency: String,
  },
  computed: {
    ...mapGetters({
      total: 'cartTotal',
      subtotal: 'cartSubTotal',
      shipping: 'cartShipping',
      fees: 'cartFees',
      prepaid: 'cartPrepaid',
      totalReduction: 'cartDiscount',
    }),
  },
  methods: {
    ...mapActions(['removeGiftCard']),
    async properRemoveGiftCard(remove) {
      await this.removeGiftCard(remove)
    },
  },
}
</script>

<style lang="scss">
.prepaid {
  @media screen and (min-width: 500px) {
    margin-left: 1rem;
  }
}

.prepaid-name {
  max-width: 50vw;

  @media screen and (min-width: 1024px) {
    max-width: 50vw;
  }

  @media screen and (min-width: 1408px) {
    max-width: 18rem;
  }
}
</style>
